import React from "react";
import { Button, Snackbar, SnackbarProps } from "@material-ui/core";
import MuiAlert, { AlertProps } from "@material-ui/lab/Alert";
import { Theme, withStyles } from "@material-ui/core/styles";
import { LimitedResourceAlertTexts } from "@udok/lib/internal/constants";

export type ResourceAlertSnackbarProps = {
  open: boolean;
  close: (viewOffers: boolean) => void;
  description?: React.ReactNode;
  anchorOrigin?: SnackbarProps["anchorOrigin"];
  autoHideDuration?: number;
};

const Alert = withStyles((theme: Theme) => ({
  icon: { alignItems: "center" },
  filledInfo: {
    backgroundColor: theme.palette.common.white,
    color: theme.palette.primary.main,
    border: `1px solid ${theme.palette.primary.main}`,
    [theme.breakpoints.down("sm")]: {
      paddingBottom: 46,
    },
  },
  message: {
    maxWidth: 400,
    whiteSpace: "break-spaces",
  },
  action: {
    [theme.breakpoints.down("sm")]: {
      paddingLeft: 0,
      position: "absolute",
      bottom: theme.spacing(1),
      left: "40%",
    },
  },
}))((props: AlertProps) => (
  <MuiAlert elevation={6} variant="filled" {...props} />
));

const ResourceAlertSnackbar = (props: ResourceAlertSnackbarProps) => {
  const {
    open,
    close,
    description = LimitedResourceAlertTexts.description,
    anchorOrigin,
    autoHideDuration = 6000,
  } = props;

  const handleClose = React.useCallback(() => {
    close(false);
  }, [close]);

  const handleViewOffers = React.useCallback(() => {
    close(true);
  }, [close]);

  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={handleClose}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "left",
        ...anchorOrigin,
      }}
    >
      <Alert
        onClose={handleClose}
        severity="info"
        action={
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={handleViewOffers}
          >
            {LimitedResourceAlertTexts.buttonLabel}
          </Button>
        }
      >
        {description}
      </Alert>
    </Snackbar>
  );
};

export default ResourceAlertSnackbar;
